import * as _ from "lodash";
import * as React from "react";

import { countDocumentRows } from "../../../Helpers/documentTable";
import * as Models from "../../../Models";
import ItemGroup, {
    AvailableServicesItemGroup,
    DocumentItemGroup,
    EditableItemGroup,
    SiteAssetsItemGroup,
    SparePartItemGroup,
    TabbedItemGroup,
} from "../ItemGroup";
import { InstalledBaseItemGroup } from "../ItemGroup/InstalledBaseItemGroup";
import RequestNewAssetContainer from "../Modal/RequestNewAssetContainer";
import { CollapsibleCard } from "./";
import ProjectAssetItemGroup from "../ItemGroup/ProjectAssetItemGroup";

interface AttributeCardsProps {
    cards: Models.DataGroup[];
    isCustomerDetail: boolean;
    // isEditMode?: boolean;
    editedItemFields?: Models.EditableItemField[];
    attributeMap?: Models.AttributeMetadata[];
    changeRequests?: Models.ChangeRequest[];
    documentGroup?: Models.AttributeGroup;
    projectAssetAttributeGroup?: Models.AttributeGroup;
    detailsName?: string;
    details?: Models.DetailView;
    match: Models.Match;
    selectedModalNavigationItem?: Models.DetailBaseData;
    onChangeFieldValue?: (editableField: Models.EditableItemField) => void;
    onClearSelectedModalNavigationItem?: () => void;
    setDirty: (value: boolean) => void;
}

interface AttributeCardChildren {
    attributeGroups: Models.AttributeGroup[];
    dataGroupName: string;
    isCustomerDetail: boolean;
    // isEditMode?: boolean;
    isBuildEquipmentData: boolean;
    isBasicData: boolean;
    editedItemFields?: Models.EditableItemField[];
    attributeMap?: Models.AttributeMetadata[];
    changeRequests?: Models.ChangeRequest[];
    documentGroup?: Models.AttributeGroup;
    projectAssetAttributeGroup?: Models.AttributeGroup;
    detailsName?: string;
    match: Models.Match;
    selectedModalNavigationItem?: Models.DetailBaseData;

    onChangeFieldValue?: (editableField: Models.EditableItemField) => void;
    onClearSelectedModalNavigationItem?: () => void;
    setDirty: (value: boolean) => void;
    details?: Models.DetailView;
}

const AttributeCardChildren: React.FC<AttributeCardChildren> = (props) => {
    const isEditable: boolean =
        (props.isBasicData || props.isBuildEquipmentData) &&
        !props.isCustomerDetail;
    const isInstalledBaseSection: boolean =
        props.dataGroupName.toLowerCase() === "installed base";
    return (
        <div className="Details__itemGroupContainer">
            {props.isBuildEquipmentData ? (
                <TabbedItemGroup // uses attributeMap
                    dataGroupName={props.dataGroupName}
                    attributeGroups={props.attributeGroups}
                    // isEditMode={props.isEditMode}
                    isEditable={isEditable}
                    editedItemFields={props.editedItemFields}
                    attributeMap={props.attributeMap}
                    isCustomerDetail={props.isCustomerDetail}
                    isInstalledBaseSection={isInstalledBaseSection}
                    onChangeFieldValue={props.onChangeFieldValue}
                    changeRequests={props.changeRequests}
                    match={props.match}
                />
            ) : (
                _.map(
                    props.attributeGroups,
                    (attributeGroup: Models.AttributeGroup) => {
                        if (
                            attributeGroup.name.toLowerCase() ===
                            "miscellaneous"
                        ) {
                            return;
                        }

                        const isSortable: boolean =
                            attributeGroup.name.toLowerCase() ===
                            "delivered services or modernisations";
                        const isFilterable: boolean =
                            isSortable && attributeGroup.rows.length > 10;

                        if (isEditable) {
                            return (
                                <EditableItemGroup //uses attributeMap
                                    key={attributeGroup.name}
                                    dataGroupName={props.dataGroupName}
                                    // isEditMode={props.isEditMode}
                                    isEditable={isEditable}
                                    editedItemFields={props.editedItemFields}
                                    attributeMap={props.attributeMap}
                                    isCustomerDetail={props.isCustomerDetail}
                                    isInstalledBaseSection={
                                        isInstalledBaseSection
                                    }
                                    onChangeFieldValue={
                                        props.onChangeFieldValue
                                    }
                                    attributeGroup={attributeGroup}
                                    changeRequests={props.changeRequests}
                                    selectedModalNavigationItem={
                                        props.selectedModalNavigationItem
                                    }
                                    onClearSelectedModalNavigationItem={
                                        props.onClearSelectedModalNavigationItem
                                    }
                                    match={props.match}
                                />
                            );
                        }

                        if (isInstalledBaseSection) {
                            return (
                                <InstalledBaseItemGroup
                                    key={attributeGroup.name}
                                    productId={props.match.params.parameter}
                                    headers={attributeGroup.headers}
                                    title={attributeGroup.name}
                                    detailsName={props.detailsName}
                                />
                            );
                        }

                        if (
                            attributeGroup.name.toLowerCase() === "spare parts"
                        ) {
                            return (
                                <SparePartItemGroup //uses attributeMap
                                    key={attributeGroup.name}
                                    dataGroupName={props.dataGroupName}
                                    // isEditMode={props.isEditMode}
                                    attributeMap={props.attributeMap}
                                    attributeGroup={attributeGroup}
                                    changeRequests={props.changeRequests}
                                    setDirty={props.setDirty}
                                    match={props.match}
                                />
                            );
                        }

                        if (attributeGroup.name.toLowerCase() === "documents") {
                            return (
                                <DocumentItemGroup
                                    key={attributeGroup.name}
                                    dataGroupName={props.dataGroupName}
                                    documentGroup={props.documentGroup}
                                    match={props.match}
                                    siteID={props.details?.siteName}
                                />
                            );
                        }

                        if (
                            attributeGroup.name.toLowerCase() === "site assets"
                        ) {
                            return (
                                <SiteAssetsItemGroup
                                    key={attributeGroup.name}
                                    dataGroupName={props.dataGroupName}
                                    attributeGroup={attributeGroup}
                                    match={props.match}
                                />
                            );
                        }
                        if (
                            attributeGroup.name.toLocaleLowerCase() ===
                            "project assets"
                        ) {
                            return (
                                <ProjectAssetItemGroup
                                    key={attributeGroup.name}
                                    dataGroupName={props.dataGroupName}
                                    projectAssetAttributeGroup={
                                        props.projectAssetAttributeGroup
                                    }
                                    headers={attributeGroup.headers}
                                    match={props.match}
                                />
                            );
                        }

                        if (
                            attributeGroup.name.toLowerCase() ===
                            "available services"
                        ) {
                            return (
                                <AvailableServicesItemGroup
                                    key={attributeGroup.name}
                                    attributeGroup={attributeGroup}
                                />
                            );
                        }

                        if (
                            attributeGroup.name.toLowerCase() ===
                                "sold to customer information" ||
                            attributeGroup.name.toLowerCase() ===
                                "site account information"
                        ) {
                            return (
                                <ItemGroup
                                    key={attributeGroup.name}
                                    sortable={isSortable}
                                    filterable={isFilterable}
                                    className={"full-width"}
                                    attributeGroup={attributeGroup}
                                />
                            );
                        }

                        return (
                            <ItemGroup
                                key={attributeGroup.name}
                                sortable={isSortable}
                                filterable={isFilterable}
                                className={
                                    props.dataGroupName.toLowerCase() ===
                                    "product data"
                                        ? "full-width"
                                        : ""
                                }
                                attributeGroup={attributeGroup}
                            />
                        );
                    }
                )
            )}
        </div>
    );
};

const AttributeCards: React.FC<AttributeCardsProps> = (
    props: AttributeCardsProps
) => {
    return (
        <div>
            {_.map(props.cards, (card: Models.DataGroup, i: number) => {
                var title: string = card.name;
                if (
                    title.toLowerCase() === "documents" &&
                    props.documentGroup
                ) {
                    title = `${title} (${countDocumentRows(
                        props.documentGroup.rows
                    )})`;
                }

                if (
                    (title.toLowerCase() === "site assets" ||
                        title?.toLowerCase() === "project assets") &&
                    props.details
                ) {
                    title = `${props.details.type} ${props.details.description} assets`;
                }

                const isBasicData: boolean = title
                    .toLowerCase()
                    .startsWith("basic");
                const isBuildEquipmentData: boolean = title
                    .toLowerCase()
                    .startsWith("equipment data");

                const attributeCardChildren: JSX.Element = (
                    <AttributeCardChildren
                        dataGroupName={title}
                        // isEditMode={props.isEditMode}
                        isBasicData={isBasicData}
                        isBuildEquipmentData={isBuildEquipmentData}
                        editedItemFields={props.editedItemFields}
                        attributeMap={props.attributeMap}
                        isCustomerDetail={props.isCustomerDetail}
                        onChangeFieldValue={props.onChangeFieldValue}
                        attributeGroups={card.attributeGroups}
                        changeRequests={props.changeRequests}
                        documentGroup={props.documentGroup}
                        projectAssetAttributeGroup={
                            props.projectAssetAttributeGroup
                        }
                        detailsName={props.detailsName}
                        setDirty={props.setDirty}
                        selectedModalNavigationItem={
                            props.selectedModalNavigationItem
                        }
                        onClearSelectedModalNavigationItem={
                            props.onClearSelectedModalNavigationItem
                        }
                        match={props.match}
                        details={props.details}
                    />
                );

                // Show on site assets table in sites view
                const showRequestNewAsset =
                    props.details?.type.toLowerCase() == "site" &&
                    card.dataGroupType == 5;
                const showLinkAddAsset =
                    props.details?.type?.toLowerCase() == "project" &&
                    card.dataGroupType == 5;
                const showButtons = showRequestNewAsset || showLinkAddAsset;
                const content: JSX.Element = showButtons ? (
                    <div>
                        <RequestNewAssetContainer
                            match={props.match}
                            showLinkAddAsset={showLinkAddAsset}
                            showRequestNewAsset={showRequestNewAsset}
                        />
                        <div className="RequestNewAsset-children">
                            {attributeCardChildren}
                        </div>
                    </div>
                ) : (
                    attributeCardChildren
                );

                return (
                    <CollapsibleCard
                        key={`${title}_${i}`}
                        title={title}
                        content={content}
                    />
                );
            })}
        </div>
    );
};

export default AttributeCards;
